import Swiper from 'swiper'

export default () => {
  new Swiper('.sc-related-posts .blog-listing_swiper', {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 24,
    breakpoints: {
      320: {
        slidesPerView: 1.2,
        spaceBetween: 24,
      },
      640: {
        slidesPerView: 2.2,
        spaceBetween: 12,
      },
      1000: {
        slidesPerView: 4,
        spaceBetween: 24,
      }
    }
  })
}
